import { useEffect, useState } from 'react'

interface ContentConsumptionDetail {
  isClassRoom?: boolean
}

type ContentConsumptionEvent = CustomEvent<ContentConsumptionDetail>

export enum EventNames {
  contentConsumption = 'app-space:contentConsumption'
}

const useContentConsumption = () => {
  const [isClassRoom, setIsClassRoom] = useState<boolean>(false)

  useEffect(() => {
    const contentConsumption = (event: Event) => {
      const customEvent = event as ContentConsumptionEvent
      setIsClassRoom(Boolean(customEvent.detail?.isClassRoom))
    }

    window.addEventListener(EventNames.contentConsumption, contentConsumption)

    return () => {
      window.removeEventListener(EventNames.contentConsumption, contentConsumption)
    }
  }, [])

  return isClassRoom
}

export default useContentConsumption
